var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.expandVersion
        ? _c("toolbar", { attrs: { title: "Personal Notification Settings" } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600" },
              model: {
                value: _vm.showRegionsDialog,
                callback: function($$v) {
                  _vm.showRegionsDialog = $$v
                },
                expression: "showRegionsDialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Select States/Provinces")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        _vm._l(_vm.referencePoliticalRegions, function(region) {
                          return _c(
                            "v-flex",
                            { key: region.postalCode, attrs: { sm4: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: region.label,
                                  value: region.postalCode
                                },
                                model: {
                                  value: _vm.politicalRegions,
                                  callback: function($$v) {
                                    _vm.politicalRegions = $$v
                                  },
                                  expression: "politicalRegions"
                                }
                              })
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "accent" },
                              on: {
                                click: function($event) {
                                  _vm.showRegionsDialog = false
                                }
                              }
                            },
                            [_vm._v("OK")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "400" },
              model: {
                value: _vm.showPhoneDialog,
                callback: function($$v) {
                  _vm.showPhoneDialog = $$v
                },
                expression: "showPhoneDialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Set up your contact phone")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Contact Phone" },
                            model: {
                              value: _vm.contactPhone,
                              callback: function($$v) {
                                _vm.contactPhone = $$v
                              },
                              expression: "contactPhone"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                loading: _vm.loadingBtn,
                                disabled: !_vm.contactPhone
                              },
                              on: { click: _vm.saveContactPhone }
                            },
                            [_vm._v("Save")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "accent", flat: "" },
                              on: { click: _vm.closePhoneDialog }
                            },
                            [_vm._v("Cancel")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: _vm.$vuetify.breakpoint.smAndDown,
                persistent: "",
                maxWidth: "1200"
              },
              model: {
                value: _vm.showPrivacyPolicy,
                callback: function($$v) {
                  _vm.showPrivacyPolicy = $$v
                },
                expression: "showPrivacyPolicy"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "title justify-center" }, [
                    _vm._v("Terms of Service")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    {
                      class: {
                        "iframe-area": !_vm.$vuetify.breakpoint.smAndDown
                      },
                      style: _vm.termsContentStyles
                    },
                    [
                      _c("iframe", {
                        staticClass: "terms",
                        attrs: { src: _vm.privacyPolicyUrl }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.acceptTerms()
                            }
                          }
                        },
                        [_vm._v("Accept")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasSelectedSms &&
          !_vm.userProfile.contactPhone &&
          !_vm.expandVersion
            ? _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: { value: true, color: "accent", type: "info" }
                        },
                        [
                          _vm._v("\n            Set up a\n            "),
                          _c(
                            "a",
                            {
                              staticStyle: { color: "white" },
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  _vm.showPhoneDialog = true
                                }
                              }
                            },
                            [_vm._v("Phone Number")]
                          ),
                          _vm._v(
                            "\n            to receive text alerts\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.profileInfo && !_vm.expandVersion
            ? _c(
                "v-layout",
                { staticClass: "my-2" },
                [
                  _c("div", { staticClass: "headline ml-2" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.profileInfo.name) +
                        " - " +
                        _vm._s(_vm.profileInfo.contactEmail) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading && _vm.expandVersion
            ? _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c(
                    "v-flex",
                    { staticClass: "text-md-center py-3" },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", color: "primary" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : !_vm.expandVersion || (_vm.expandVersion && !_vm.loading)
            ? _c(
                "v-layout",
                { staticClass: "my-2", attrs: { column: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "py-2 pl-4" },
                    [
                      _c("v-layout", { attrs: { "align-baseline": "" } }, [
                        _vm.expandVersion
                          ? _c("div", { staticClass: "title mr-3 mt-2 mb-2" }, [
                              _vm._v(
                                "\n              User notifications\n            "
                              )
                            ])
                          : _c("div", { staticClass: "title mr-3 mt-4 mb-5" }, [
                              _vm._v(
                                "\n              When and how to send notifications\n            "
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _vm.isLoadboardEnabled
                        ? _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c("v-flex", [
                                _c("span", { staticClass: "subheading" }, [
                                  _vm._v("Loadboard Subscription")
                                ]),
                                _vm._v(" "),
                                _c("ul", { staticClass: "ml-2" }, [
                                  _c("li", [
                                    _vm._v(
                                      "When new loads are posted in the states you select"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    [
                                      _vm._v(
                                        "Selected states:\n                  "
                                      ),
                                      !_vm.savedPoliticalRegions.length
                                        ? _c(
                                            "span",
                                            { staticClass: "font-italic" },
                                            [_vm._v("No states selected.")]
                                          )
                                        : _vm._l(
                                            _vm.savedPoliticalRegions,
                                            function(region, idx) {
                                              return _c("span", { key: idx }, [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm
                                                        .referencePoliticalRegionsMappedByPostalCode[
                                                        region
                                                      ].label
                                                    ) +
                                                    "\n                      "
                                                ),
                                                idx + 1 !=
                                                _vm.savedPoliticalRegions.length
                                                  ? _c("span", [_vm._v(",")])
                                                  : _vm._e()
                                              ])
                                            }
                                          )
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "justify-end" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "primary ml-5",
                                        on: {
                                          click: function($event) {
                                            _vm.showRegionsDialog = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Select States/Regions\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "pt-3",
                                  attrs: { xs12: "", sm6: "", md3: "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { staticClass: "md2 xs6" },
                                        [
                                          _c("v-checkbox", {
                                            attrs: { label: "Text" },
                                            model: {
                                              value: _vm.loadboard.sms,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.loadboard,
                                                  "sms",
                                                  $$v
                                                )
                                              },
                                              expression: "loadboard.sms"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { staticClass: "md2 xs6" },
                                        [
                                          _c("v-checkbox", {
                                            attrs: { label: "Email" },
                                            model: {
                                              value: _vm.loadboard.email,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.loadboard,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "loadboard.email"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isLoadboardEnabled ? _c("v-divider") : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            column: !_vm.expandVersion,
                            wrap: _vm.expandVersion
                          }
                        },
                        [
                          _vm.isLoadboardEnabled
                            ? _c(
                                "v-layout",
                                {
                                  staticClass: "mt-2",
                                  attrs: { column: "", sm12: "" }
                                },
                                [
                                  _c("v-flex", [
                                    _c("span", { staticClass: "subheading" }, [
                                      _vm._v("Listings Subscription")
                                    ]),
                                    _vm._v(" "),
                                    _c("ul", { staticClass: "ml-4" }, [
                                      _vm.isLoadboardBiddingEnabled
                                        ? _c("li", [
                                            _vm._v(
                                              "New and updated bids on your listings"
                                            )
                                          ])
                                        : _c("li", [
                                            _vm._v("Activity on your listings")
                                          ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "pt-3",
                                      attrs: { xs12: "", sm6: "", md3: "" }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "xs6",
                                              class: {
                                                md2: !_vm.expandVersion,
                                                md3: _vm.expandVersion
                                              }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                attrs: { label: "Text" },
                                                model: {
                                                  value: _vm.listings.sms,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.listings,
                                                      "sms",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "listings.sms"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "xs6",
                                              class: {
                                                md2: !_vm.expandVersion,
                                                md3: _vm.expandVersion
                                              }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                attrs: { label: "Email" },
                                                model: {
                                                  value: _vm.listings.email,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.listings,
                                                      "email",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "listings.email"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isLoadboardEnabled ? _c("v-divider") : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            {
                              staticClass: "mt-2",
                              attrs: { column: "", sm12: "" }
                            },
                            [
                              _c("v-flex", [
                                _c("span", { staticClass: "subheading" }, [
                                  _vm._v("Load History Subscription")
                                ]),
                                _vm._v(" "),
                                _c("ul", { staticClass: "ml-4" }, [
                                  _c("li", [_vm._v("Pickup ETA Updates")]),
                                  _vm._v(" "),
                                  _c("li", [_vm._v("Pickup")]),
                                  _vm._v(" "),
                                  _c("li", [_vm._v("Delivery ETA Updates")]),
                                  _vm._v(" "),
                                  _c("li", [_vm._v("Delivery")]),
                                  _vm._v(" "),
                                  _c("li", [_vm._v("Chat Log Entries")])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "pt-3",
                                  attrs: { xs12: "", sm6: "", md3: "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "xs6",
                                          class: {
                                            md2: !_vm.expandVersion,
                                            md3: _vm.expandVersion
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: { label: "Text" },
                                            model: {
                                              value: _vm.loadsInProgress.sms,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.loadsInProgress,
                                                  "sms",
                                                  $$v
                                                )
                                              },
                                              expression: "loadsInProgress.sms"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "xs6",
                                          class: {
                                            md2: !_vm.expandVersion,
                                            md3: _vm.expandVersion
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: { label: "Email" },
                                            model: {
                                              value: _vm.loadsInProgress.email,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.loadsInProgress,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "loadsInProgress.email"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.expandVersion ? _c("v-divider") : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            column: !_vm.expandVersion,
                            wrap: _vm.expandVersion
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "mt-2",
                              attrs: { column: "", sm12: "" }
                            },
                            [
                              _c("v-flex", [
                                _c("span", { staticClass: "subheading" }, [
                                  _vm._v("Dispatching Subscription")
                                ]),
                                _vm._v(" "),
                                _c("ul", { staticClass: "ml-4" }, [
                                  _c("li", [
                                    _vm._v(
                                      "Preferred Carrier Network (PCN) Invitations and Membership"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [_vm._v("Network Loads Available")]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v("Your Offered Loads Accepted")
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "Activity on Network loads you follow"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "pt-3",
                                  attrs: { xs12: "", sm6: "", md3: "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "xs6",
                                          class: {
                                            md2: !_vm.expandVersion,
                                            md3: _vm.expandVersion
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: { label: "Text" },
                                            model: {
                                              value: _vm.dispatching.sms,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dispatching,
                                                  "sms",
                                                  $$v
                                                )
                                              },
                                              expression: "dispatching.sms"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "xs6",
                                          class: {
                                            md2: !_vm.expandVersion,
                                            md3: _vm.expandVersion
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: { label: "Email" },
                                            model: {
                                              value: _vm.dispatching.email,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dispatching,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "dispatching.email"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _vm.isLoadboardBiddingEnabled
                            ? _c(
                                "v-layout",
                                {
                                  staticClass: "mt-2",
                                  attrs: { column: "", sm12: "" }
                                },
                                [
                                  _c("v-flex", [
                                    _c("span", { staticClass: "subheading" }, [
                                      _vm._v("Bids Subscription")
                                    ]),
                                    _vm._v(" "),
                                    _c("ul", [
                                      _c("li", [_vm._v("Outbid")]),
                                      _vm._v(" "),
                                      _c("li", [_vm._v("Bid Accepted")]),
                                      _vm._v(" "),
                                      _c("li", [_vm._v("Listing Closed")])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "pt-3",
                                      attrs: { xs12: "", sm6: "", md3: "" }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "xs6",
                                              class: {
                                                md2: !_vm.expandVersion,
                                                md3: _vm.expandVersion
                                              }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                attrs: { label: "Text" },
                                                model: {
                                                  value: _vm.bids.sms,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.bids,
                                                      "sms",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "bids.sms"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "xs6",
                                              class: {
                                                md2: !_vm.expandVersion,
                                                md3: _vm.expandVersion
                                              }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                attrs: { label: "Email" },
                                                model: {
                                                  value: _vm.bids.email,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.bids,
                                                      "email",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "bids.email"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isLoadboardBiddingEnabled
                            ? _c("v-divider")
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.expandVersion ? _c("v-divider") : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          staticClass: "mt-2",
                          attrs: { column: "", sm12: "" }
                        },
                        [
                          _c(
                            "v-flex",
                            [
                              _c(
                                "span",
                                {
                                  class: {
                                    subheading: true,
                                    "font-weight-bold": _vm.hasSelectedSms
                                  }
                                },
                                [_vm._v("Text Messaging Opt In")]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                {
                                  class: {
                                    "font-weight-light": !_vm.hasSelectedSms
                                  }
                                },
                                [
                                  _c("li", [
                                    _vm._v(
                                      "We'll send you text messages from Livestock Transport Nation (LTN)."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v("Message and data rates may apply.")
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v("Message frequency varies.")
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v("At any time you can text "),
                                    _c("code", [_vm._v("HELP")]),
                                    _vm._v(" for help or "),
                                    _c("code", [_vm._v("STOP")]),
                                    _vm._v(" to opt out.")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                [
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              disabled: !_vm.hasSelectedSms
                                            },
                                            model: {
                                              value: _vm.confirmSmsDelivery,
                                              callback: function($$v) {
                                                _vm.confirmSmsDelivery = $$v
                                              },
                                              expression: "confirmSmsDelivery"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        {
                                          class: {
                                            "font-weight-light": !_vm.hasSelectedSms
                                          },
                                          attrs: {
                                            disabled: !_vm.hasSelectedSms
                                          }
                                        },
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                      I would like communications by text\n                    "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.priorConfirmSmsDelivery
                                            ? _c(
                                                "v-list-tile-sub-title",
                                                { staticClass: "font-italic" },
                                                [
                                                  _vm._v(
                                                    "\n                      Opted in since " +
                                                      _vm._s(
                                                        _vm._f("formatDate")(
                                                          _vm.priorConfirmSmsDelivery
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "v-list-tile-sub-title",
                                                { staticClass: "font-italic" },
                                                [
                                                  _vm._v(
                                                    "\n                      Not previously opted in.\n                    "
                                                  )
                                                ]
                                              )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c("v-list-tile-action"),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              on: {
                                                click: function($event) {
                                                  _vm.showPrivacyPolicy = true
                                                }
                                              }
                                            },
                                            [_vm._v("Privacy Policy")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pt-3",
                              attrs: { xs12: "", sm12: "", md3: "" }
                            },
                            [_c("v-layout", { attrs: { row: "", wrap: "" } })],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.expandVersion ? _c("v-divider") : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { "pt-4": "" } },
                        [
                          _c(
                            "v-flex",
                            { staticClass: "mr-5", attrs: { sm3: "" } },
                            [
                              _c(
                                "sticky-footer",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "accent",
                                      attrs: {
                                        disabled: _vm.disableSaveSettingsButton
                                      },
                                      on: { click: _vm.updateSettings }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Save Settings\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3881931e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3881931e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/User/NotificationSettings.vue
// module id = null
// module chunks = 